export default (state, action) => ({}[action.type] || state);
